<script>
    import {pop} from 'svelte-spa-router'
    import ThresholdsEdit from './silo_thresholds_edit.svelte'
    import InfosEdit from './silo_infos_edit.svelte'

    import {fade} from 'svelte/transition'

    import {get_sensor_id} from '../gqlQueries'
    import {DEFAULT_SENSOR_INFOS, getSensorInformation, updateSensorInformation} from "../firestore"

    import {of} from 'rxjs'
    import {catchError, mergeMap, tap} from "rxjs/operators"

    export let params = {};
    let id = params.id;

    let equipment = undefined;
    let modifiedEquipment = {infos: DEFAULT_SENSOR_INFOS};
    let tempEquipment = undefined;

    get_sensor_id({id: id, messages: false}).pipe(
            tap(data => tempEquipment = data),
            mergeMap(data => getSensorInformation({id: data.id, client: ""}).pipe(
                    catchError(() => of(DEFAULT_SENSOR_INFOS))
            ))
    ).subscribe(data => {
        tempEquipment.infos = data;
        equipment = tempEquipment;
        if (!equipment.infos) modifiedEquipment = {...equipment, infos: {...DEFAULT_SENSOR_INFOS}};
        else modifiedEquipment = {...equipment}
    });

    function cancel() {
        pop();
    }

    function save() {
        updateSensorInformation(equipment.id, modifiedEquipment.infos);
        pop();
    }
</script>

{#if equipment}
    <div class="container-fluid" transition:fade="{{duration: 200}}">
        <div class="row page-titles">
            <div class="col-md-5 col-8 align-self-center">
                <h3 class="text-themecolor">Equipment Summary</h3>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">Sites Overview</li>
                    <li class="breadcrumb-item"><a href="#/equipment">Equipment Summary</a></li>
                    <li class="breadcrumb-item"><a href="#/equipment/{equipment.id}">{equipment.infos.name}</a>
                    </li>
                    <li class="breadcrumb-item active">Modification</li>
                </ol>
            </div>
        </div>

        <section>
            <div class="card-group separate">
                <InfosEdit equipment={equipment} bind:modifiedEquipment={modifiedEquipment}/>
                {#if equipment.infos.thresholds}
                    <ThresholdsEdit bind:modifiedEquipment={modifiedEquipment}/>
                {/if}
            </div>
        </section>

        <button on:click={save} class="btn btn-primary">Save</button>
        <button on:click={cancel} class="btn btn-outline-danger">Cancel</button>
    </div>
{/if}